import { DashboardConstants } from '../../actions/constant';

const {
GET_DASHBOARD_THERAPY_LOADER,
GET_DASHBOARD_THERAPY_REQUEST,
GET_DASHBOARD_THERAPY_FAILURE,
GET_DASHBOARD_THERAPY_SUCCESS
} = DashboardConstants;

const intitialstate: object = {
  response: null,
  isError: false,
  loading: false,
};

export const dashboardTherapyReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_THERAPY_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DASHBOARD_THERAPY_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_DASHBOARD_THERAPY_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
